"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAccessRefined = void 0;
// Note: AccessProperties is the top-level, children is all others, please avoid recursion
const buildAccessRefined = (accessProperties, children) => ({
    ID: accessProperties.ID,
    metadata: {
        created: accessProperties.metadata.created,
        updated: accessProperties.metadata.updated,
    },
    code: accessProperties.code,
    name: accessProperties.name,
    type: accessProperties.type,
    parent: accessProperties.parent ?? null,
    children: children
        .filter((child) => child.parent.ID == accessProperties.ID)
        .map((child) => (0, exports.buildAccessRefined)(child, children)),
    customAttributes: accessProperties.customAttributes,
});
exports.buildAccessRefined = buildAccessRefined;
//# sourceMappingURL=AccessRefined.js.map